import React from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const PieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

                    //{scope}/aggregatedsumfinancial/{collection}/{aggregationfield}/{sumfield}
    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Listing value by Area")}
                        dataProviderName={"statisticsviews/listingsvalueperarea/aggregatedsumfinancial/views_opportunities_listing/_related_area_name/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box> 
                <Box className="report-item">
                    <Pie
                        title={t("Listing value by Shop")}
                        dataProviderName={"statisticsviews/listingsvaluepershop/aggregatedsumfinancial/views_opportunities_listing/_related_shop_name/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Listing value by Agent")}
                        dataProviderName={"statisticsviews/listingsvalueperagent/aggregatedsumfinancial/views_opportunities_listing/_related_agent_fullname/value"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_agent_fullname', addFilter)}
                    />
                </Box>
            </Box>

            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Properties Listed by Area")}
                        dataProviderName={"statisticsviews/listingsquantityperarea/aggregatedsum/views_opportunities_listing/_related_area_name/quantity"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box> 
                <Box className="report-item">
                    <Pie
                        title={t("Properties Listed by Shop")}
                        dataProviderName={"statisticsviews/listingsquantitypershop/aggregatedsum/views_opportunities_listing/_related_shop_name/quantity"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Properties Listed by Agent")}
                        dataProviderName={"statisticsviews/listingsquantityperagent/aggregatedsum/views_opportunities_listing/_related_agent_fullname/quantity"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_agent_fullname', addFilter)}
                    />
                </Box>
            </Box>

            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Listing rows by Area")}
                        dataProviderName={"statisticsviews/listingsrowsperarea/aggregated/views_opportunities_listing/_related_area_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box> 
                <Box className="report-item">
                    <Pie
                        title={t("Listing rows by Shop")}
                        dataProviderName={"statisticsviews/listingsrowspershop/aggregated/views_opportunities_listing/_related_shop_name"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Listing rows by Agent")}
                        dataProviderName={"statisticsviews/listingsrowsperagent/aggregated/views_opportunities_listing/_related_agent_fullname"}
                        filters={filterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_agent_fullname', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default PieSet;